import axios from "axios";
import { getLocalStorage } from "components/Helper/Helper";
import {
  SET_FIRST_CHAT,
  SET_RETRIEVAL_MODE,
  SET_CHAT_LIST,
  SET_LOADER_STATUS,
  SET_BATCH_ID,
  URL_UPLOAD,
  URL_VECTORISE,
  GET_CHAT_HISTORY,
  SET_CHAT_LIST_NEXT_URL,
  SET_CHAT_LIST_HAS_MORE,
  URL_CHAT_MESSAGES,
  SET_SEARCH,
  SET_THINKING_MODE,
} from "./constants";
import { errorToastMessage, successToastMessage } from "utils/errorToast";

export function setFirstChat(status) {
  return {
    type: SET_FIRST_CHAT,
    firstChat: status,
  };
}

export function setRetrievalMode(mode) {
  return {
    type: SET_RETRIEVAL_MODE,
    retrievalMode: mode,
  };
}

export function setChatList(list) {
  return {
    type: SET_CHAT_LIST,
    chatList: list,
  };
}

export function setSearch(search) {
  return {
    type: SET_SEARCH,
    search: search,
  };
}

export function setThinkingMode(mode) {
  return {
    type: SET_THINKING_MODE,
    thinkingMode: mode,
  };
}

export function loader(status) {
  return {
    type: SET_LOADER_STATUS,
    loaderStatus: status,
  };
}

export function setBatchId(batchId) {
  return {
    type: SET_BATCH_ID,
    batchId: batchId,
  };
}

export const onCallUpload = (data) => {
  return async (dispatch) => {
    // dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: URL_UPLOAD,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.success) {
        const batchId = response.data.data?.batch_id;
        if (batchId) {
          dispatch(setBatchId(batchId));
        }
        // successToastMessage(
        //   response.data.message || "Files uploaded successfully",
        // );
        return { success: true, batchId, files: response.data.data?.files };
      } else {
        errorToastMessage(response.data.message || "Upload failed");
        return { success: false };
      }
    } catch (error) {
      console.error(error);
      errorToastMessage("Upload failed. Please try again.");
      return { success: false };
    } finally {
      dispatch(loader(false));
    }
  };
};

export const sendVectorize = (batchId) => {
  const data = { batch_id: batchId };
  return async (dispatch) => {
    // dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: URL_VECTORISE,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.success) {
        return { success: true, batchId, files: response.data.data?.files };
      } else {
        errorToastMessage(response.data.message || "Vectorization failed");
        return { success: false };
      }
    } catch (error) {
      console.error(error);
      errorToastMessage("Vectorization failed. Please try again.");
      return { success: false };
    } finally {
      dispatch(loader(false));
    }
  };
};

export function setChatListNextUrl(url) {
  return {
    type: SET_CHAT_LIST_NEXT_URL,
    chatListNextUrl: url,
  };
}

export function setChatListHasMore(hasMore) {
  return {
    type: SET_CHAT_LIST_HAS_MORE,
    chatListHasMore: hasMore,
  };
}

export const getChatHistoryList = (isLoadMore = false) => {
  return async (dispatch, getState) => {
    const state = getState().chatBotReducer;
    const searchQuery = state.search || "";
    
    // Build base URL with search parameter
    let baseUrl = GET_CHAT_HISTORY;
    if (searchQuery) {
      baseUrl = `${GET_CHAT_HISTORY}&search=${encodeURIComponent(searchQuery)}`;
    }
    
    const url = isLoadMore && state.chatListNextUrl ? state.chatListNextUrl : baseUrl;

    // Don't fetch if loading more but no next URL
    if (isLoadMore && !state.chatListNextUrl) {
      return { success: false, noMore: true };
    }

    // dispatch(loader(true));

    try {
      const response = await axios({
        method: "get",
        url: url,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      console.log("Chat history API response:", response.data);

      if (response.data.success) {
        // Handle both response structures: data.data or data directly containing array
        const responseData = response.data.data;
        const newData = Array.isArray(responseData) ? responseData : (responseData?.data || []);
        let nextUrl = Array.isArray(responseData) ? response.data.next : (responseData?.next || null);

        // Ensure next URL uses same protocol as initial URL (fix http/https mismatch)
        if (nextUrl && GET_CHAT_HISTORY.startsWith('https://')) {
          nextUrl = nextUrl.replace(/^http:/, 'https:');
        }

        // console.log("Parsed chat data:", newData);

        if (isLoadMore) {
          // Append to existing list
          const existingList = state.chatList || [];
          dispatch(setChatList([...existingList, ...newData]));
        } else {
          // Replace list (initial load)
          dispatch(setChatList(newData));
        }

        dispatch(setChatListNextUrl(nextUrl));
        dispatch(setChatListHasMore(!!nextUrl));

        return { success: true, data: newData, hasMore: !!nextUrl };
      } else {
        if (!isLoadMore) {
          dispatch(setChatList([]));
        }
        dispatch(setChatListHasMore(false));
        return { success: false };
      }
    } catch (error) {
      console.error("Error fetching chat history:", error);
      if (!isLoadMore) {
        dispatch(setChatList([]));
      }
      dispatch(setChatListHasMore(false));
      return { success: false };
    } finally {
      dispatch(loader(false));
    }
  };
};

export const getChatMessages = (conversationId) => {
  return async (dispatch) => {
    dispatch(loader(true));

    try {
      const response = await axios({
        method: "get",
        url: `${URL_CHAT_MESSAGES}${conversationId}/`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      // console.log("Chat messages API response:", response.data);

      if (response.data.success) {
        const messages = response.data.data || [];
        return { success: true, data: messages };
      } else {
        return { success: false };
      }
    } catch (error) {
      console.error("Error fetching chat messages:", error);
      return { success: false };
    } finally {
      dispatch(loader(false));
    }
  };
};
// };
